const CUSTOM_FIELDS_TYPES = Object.freeze({
  object: 'object',
  text: 'text',
  dropdown: 'dropdown',
  select: 'select',
  date: 'date',
  datetime: 'datetime',
  day: 'day',
  number: 'number',
  currency: 'currency',
  percent: 'percent',
  dropdownMultiple: 'dropdown-multiple',
  user: 'user',
  condition: 'condition',
  email: 'email',
  link: 'link',
  account: 'account',
  task: 'task',
  textLong: 'text-long',
  multiSelect: 'multi-select',
  taskLink: 'task-link',
  taskBackLink: 'task-back-link',
} as const)

// Types only the backend creates, on the two predefined task dependency
// columns. They are never offered in a type picker, and the surfaces that do
// not support them (filters, automations, vForms, the child object page) use
// this list to skip such columns.
export const TASK_LINK_FIELD_TYPES = Object.freeze([
  CUSTOM_FIELDS_TYPES.taskLink,
  CUSTOM_FIELDS_TYPES.taskBackLink,
])

export default CUSTOM_FIELDS_TYPES
